import React, {useState} from 'react'
import Indicator from '_core/components/Indicator/Indicator'
import PaymentMethodForm from 'app/features/customers/customer/components/CustomerPayments/PaymentMethodForm'
import PaymentMethodListItem from './PaymentmethodListItem'
import PaginationList from 'app/components/pagination/PaginationList'
import find from 'lodash/find'

const pageSize = 10
type Props = {
  paymentList: any[]
  addressList: any[]
  isFetching: boolean
  onClose: (id?: string) => void
  customerId: string
  onChangePayment: (value: any) => any
  checkPaymentMethodId?: any
  children?: React.ReactNode
  isSubmitting?: boolean
  paymentDialog: boolean
  onValidate: (id: string) => void
  addressFetching?: boolean
  onPrimary: (id: string) => void
}
const PaymentList: React.FC<Props> = ({
  paymentList,
  addressList,
  isFetching,
  onClose,
  onChangePayment,
  customerId,
  checkPaymentMethodId,
  children,
  isSubmitting,
  paymentDialog,
  onValidate,
  addressFetching,
  onPrimary,
}) => {
  const [selectedPayment, setSelectedPayment] = useState<any>({})
  const [currentPage, setCurrentPage] = useState<any>(1)

  const handleSelectPayment = (payment: any) => {
    setSelectedPayment(payment)
  }

  const handleChangePayment = () => {
    const payment = find(paymentList, {id: selectedPayment.id})
    onChangePayment(payment)
  }

  const handleSelectWithClose = (id?: string) => {
    if (id) {
      setSelectedPayment({id})
    }
    onClose(id)
  }

  if (isFetching && !paymentList?.length) {
    return Loader()
  }

  const newPaymentMethod = (
    <div className='mx-7'>
      <PaymentMethodForm
        onClose={handleSelectWithClose}
        customerId={customerId}
        addressList={addressList}
        isAddressFetch={addressFetching}
      />
    </div>
  )

  if (paymentDialog) {
    return newPaymentMethod
  }

  if (paymentList.length > 0) {
    const handlePageChange = async (currentPage: any) => {
      setCurrentPage(currentPage)
    }

    const lastIndex = pageSize * currentPage
    const firstIndex = lastIndex - pageSize
    return (
      <>
        <div className='row m-7'>
          {paymentList.slice(firstIndex, lastIndex).map((payment) => {
            return (
              <PaymentMethodListItem
                checkedPaymentMethodId={checkPaymentMethodId}
                key={payment.id}
                payment={payment}
                address={payment.address}
                paymentMethodId={selectedPayment.id}
                onPaymentChange={handleSelectPayment}
                onValidate={onValidate}
                onPrimary={onPrimary}
              />
            )
          })}
        </div>
        <div className='mb-5'>
          <PaginationList
            totalCount={paymentList.length}
            onPageChange={handlePageChange}
            currentPage={currentPage}
            pageSize={pageSize}
            className='mx-5'
          />
        </div>
        <div className='modal-footer'>
          <button
            id='btnAddressClose'
            className='btn explore-btn-outline me-5'
            onClick={() => onClose()}
          >
            Cancel
          </button>
          {children && children}
          <button
            id='btnSave'
            type='button'
            title='Change'
            disabled={!selectedPayment.id}
            className='btn-primary btn'
            onClick={handleChangePayment}
          >
            {isSubmitting ? (
              <Indicator text=' Please wait...' />
            ) : paymentList.length === 1 ? (
              'Save'
            ) : (
              'Change'
            )}
          </button>
        </div>
      </>
    )
  }
  return newPaymentMethod
}

export default PaymentList

function Loader() {
  return (
    <div className='modal-body align-items-center pt-5'>
      <div className='d-flex justify-content-center '>
        <label>
          <span className='indicator-progress d-block'>
            <span className='spinner-border ms-5 align-middle text-info'></span>
          </span>
        </label>
      </div>
    </div>
  )
}
